import React from 'react';
import ProductSidebarComponent from './ProductSidebarComponent';
import { PageHeader } from '../../components';

const IndustrialWaterTreatmentPlants: React.FC = () => {
  return (
    <>
      <PageHeader customClass='bg-breadcrumb-om' title="Industrial Water Treatment Plants – O&M Services" breadcrumbs={[{ label: "Products", path: "/products" }]} />

      <div className="container-fluid py-5 wow fadeInUp" data-wow-delay="0.1s"
        style={{ visibility: "visible", animationDelay: "0.1s", animationName: "fadeInUp" }}>
        <div className="container">
          <div className="row g-5">

            <div className="col-lg-8">
              <div className="row g-3 mb-5">
                <div className="col-md-6">
                  <img className="img-fluid" src="img/industrial-3.jpg" alt="" />
                </div>
                <div className="col-md-6">
                  <img className="img-fluid" src="img/industrial-1.jpg" alt="" />
                </div>
              </div>
              <h1 className="mb-4">Industrial Water Treatment Plants – O&M Services</h1>
              
              <h3 className="mb-4">Overview</h3>
              <p>Industrial operations rely heavily on consistent water quality for processes, utilities, and product quality. At Wasser Technochem (I) Ltd., we provide expert Operation & Maintenance (O&M) services for industrial water treatment plants (WTPs) including DM plants, RO systems, softeners, and filtration systems.</p>
              <p>Our O&M programs are designed to maximize uptime, maintain treatment quality, reduce chemical and energy consumption, and ensure compliance with internal quality norms and external discharge standards.</p>

              <h3 className="mb-4">Scope of Services</h3>
              <div className="row g-4 mb-4">
                <div className="col-md-6">
                  <p><i className="fa fa-clock text-primary me-2"></i>Day-to-day plant operation with shift-wise attendance</p>
                </div>
                <div className="col-md-6">
                  <p><i className="fa fa-flask text-primary me-2"></i>Water quality testing & analysis (TDS, conductivity, hardness, etc.)</p>
                </div>
                <div className="col-md-6">
                  <p><i className="fa fa-wrench text-primary me-2"></i>Preventive maintenance of pumps, membranes, valves, and dosing systems</p>
                </div>
                <div className="col-md-6">
                  <p><i className="fa fa-boxes text-primary me-2"></i>Inventory tracking for chemicals, membranes, filters</p>
                </div>
                <div className="col-md-6">
                  <p><i className="fa fa-sync text-primary me-2"></i>CIP of RO membranes and resin regeneration for DM systems</p>
                </div>
                <div className="col-md-6">
                  <p><i className="fa fa-microchip text-primary me-2"></i>Instrument calibration, panel health checks, and SCADA support</p>
                </div>
                <div className="col-md-6">
                  <p><i className="fa fa-satellite text-primary me-2"></i>Remote monitoring and performance reporting</p>
                </div>
              </div>

              <h3 className="mb-4">Coverage</h3>
              <div className="row g-4 mb-4">
                <div className="col-md-6">
                  <div className="service-item">
                    <div className="overflow-hidden">
                      <h5><i className="fa fa-bolt text-primary me-2"></i>Power & Cement Plants</h5>
                      <p>RO + DM + Softener Plants in power, cement, and textile units</p>
                    </div>
                  </div>
                </div>
                <div className="col-md-6">
                  <div className="service-item">
                    <div className="overflow-hidden">
                      <h5><i className="fa fa-apple-alt text-primary me-2"></i>Food & Beverage</h5>
                      <p>Process water systems for food, beverage, pharma industries</p>
                    </div>
                  </div>
                </div>
                <div className="col-md-6">
                  <div className="service-item">
                    <div className="overflow-hidden">
                      <h5><i className="fa fa-car text-primary me-2"></i>Manufacturing & Automotive</h5>
                      <p>Water polishing systems in manufacturing and automotive sectors</p>
                    </div>
                  </div>
                </div>
                <div className="col-md-6">
                  <div className="service-item">
                    <div className="overflow-hidden">
                      <h5><i className="fa fa-thermometer-half text-primary me-2"></i>Utility Systems</h5>
                      <p>Utility systems for HVAC, steam, and high-purity applications</p>
                    </div>
                  </div>
                </div>
              </div>

              <h3 className="mb-4">Benefits</h3>
              <div className="row g-4 mb-5">
                <div className="col-md-6">
                  <h5><i className="fa fa-check-circle text-success me-2"></i>Consistent Quality</h5>
                  <p>Consistent treated water quality for critical industrial applications</p>
                </div>
                <div className="col-md-6">
                  <h5><i className="fa fa-check-circle text-success me-2"></i>Cost Reduction</h5>
                  <p>Reduced chemical usage and energy costs</p>
                </div>
                <div className="col-md-6">
                  <h5><i className="fa fa-check-circle text-success me-2"></i>Minimized Downtime</h5>
                  <p>Minimized breakdowns and plant shutdowns</p>
                </div>
                <div className="col-md-6">
                  <h5><i className="fa fa-check-circle text-success me-2"></i>Expert Operations</h5>
                  <p>Skilled operators with process-specific knowledge</p>
                </div>
                <div className="col-md-12">
                  <h5><i className="fa fa-check-circle text-success me-2"></i>Performance Monitoring</h5>
                  <p>KPI-based reporting with operational dashboards</p>
                </div>
              </div>

              <h3 className="mb-4">Why WTIL?</h3>
              <div className="row g-4">
                <div className="col-md-12">
                  <div className="d-flex">
                    <div className="flex-shrink-0 btn-square bg-primary rounded-circle" style={{ width: "64px", height: "64px" }}>
                      <i className="fa fa-chart-line text-white"></i>
                    </div>
                    <div className="ms-4">
                      <h5>Proven Capacity Range</h5>
                      <p className="mb-0">Experience managing WTPs from 10 m³/hr to 300 m³/hr across sectors</p>
                    </div>
                  </div>
                </div>
                <div className="col-md-12">
                  <div className="d-flex">
                    <div className="flex-shrink-0 btn-square bg-primary rounded-circle" style={{ width: "64px", height: "64px" }}>
                      <i className="fa fa-flask text-white"></i>
                    </div>
                    <div className="ms-4">
                      <h5>Chemical Integration</h5>
                      <p className="mb-0">SANYOL® WT chemical integration for higher efficiency</p>
                    </div>
                  </div>
                </div>
                <div className="col-md-12">
                  <div className="d-flex">
                    <div className="flex-shrink-0 btn-square bg-primary rounded-circle" style={{ width: "64px", height: "64px" }}>
                      <i className="fa fa-industry text-white"></i>
                    </div>
                    <div className="ms-4">
                      <h5>Multi-Sector Experience</h5>
                      <p className="mb-0">Proven results in textile, cement, power, and pharma sectors</p>
                    </div>
                  </div>
                </div>
                <div className="col-md-12">
                  <div className="d-flex">
                    <div className="flex-shrink-0 btn-square bg-primary rounded-circle" style={{ width: "64px", height: "64px" }}>
                      <i className="fa fa-phone text-white"></i>
                    </div>
                    <div className="ms-4">
                      <h5>24/7 Support</h5>
                      <p className="mb-0">On-call technical support and site audits by central team</p>
                    </div>
                  </div>
                </div>
                <div className="col-md-12">
                  <div className="d-flex">
                    <div className="flex-shrink-0 btn-square bg-primary rounded-circle" style={{ width: "64px", height: "64px" }}>
                      <i className="fa fa-graduation-cap text-white"></i>
                    </div>
                    <div className="ms-4">
                      <h5>Comprehensive Training</h5>
                      <p className="mb-0">Ability to integrate training, SOPs, and performance benchmarking</p>
                    </div>
                  </div>
                </div>
              </div>
            </div>

            <div className="col-lg-4">
              <ProductSidebarComponent />
            </div>

          </div>
        </div>
      </div>
    </>
  );
};

export default IndustrialWaterTreatmentPlants;
